import { useTranslation } from 'react-i18next'

import { ArrowRightIcon } from '@phosphor-icons/react'

import { Alert, Button } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const VisibilityCriteriaEmptyState = ({ onGoToCriteria }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Alert type="info">
        {t('Todavía no hay criterios de visibilidad. Créalos en la pestaña Criterios de visibilidad.')}
      </Alert>
      <Button variant="text" size="s" onClick={onGoToCriteria}>
        {t('Ir a Criterios de visibilidad')}
        <ArrowRightIcon size={16} />
      </Button>
    </Styles.Container>
  )
}

export default VisibilityCriteriaEmptyState
